@let header = globalDataService.config().header;
<div
  class="page-content"
  [class.page-content--admin-mode]="adminMode"
  [class.is-scrolling]="isScrolling"
  [class.has-topper]="header.data.headerTopper.display"
>
  <app-header
    [styles]="header.data.styles"
    [logoDisplay]="header.data.logo.display"
    [logoSrc]="header.data.logo.src_data"
    [logoRedirect]="header.data.logo.redirect"
    [topperDisplay]="header.data.headerTopper.display"
    [topperPhone]="header.data.headerTopper.phone"
    [menuItems]="header.data.menu ?? defaultHeaderMenuItems"
  ></app-header>
  <section class="container">
    <div class="page404">
      <mat-icon class="material-symbols-outlined">warning</mat-icon>
      <h1 class="page404__title h5">Problem loading page</h1>
      <p class="page404__text body2">This page is not found.</p>
    </div>
  </section>
  @let footer = globalDataService.config().footer;
  <app-footer
    [config]="footer"
  />
</div>
